import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import FloatingWhatsApp from "@/components/feature/FloatingWhatsApp";
import { AdminAuthProvider } from "@/hooks/useAdminAuth";

/** Scrolls the window back to the top whenever the route changes. */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppShell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) {
    return <AppRoutes />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <AppRoutes />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

function App() {
  useEffect(() => {
    // Keep the <html lang> in sync with the active language (en/fr).
    const syncLang = (lng?: string) => {
      document.documentElement.lang = lng && lng.startsWith("fr") ? "fr" : "en";
    };
    syncLang(i18n.language);
    i18n.on("languageChanged", syncLang);
    return () => {
      i18n.off("languageChanged", syncLang);
    };
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <AdminAuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <ScrollToTop />
          <AppShell />
        </BrowserRouter>
      </AdminAuthProvider>
    </I18nextProvider>
  );
}

export default App;